import { UI } from '@cowprotocol/ui'

import styled from 'styled-components/macro'

export const OrderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: var(${UI.COLOR_PAPER});
  border-radius: 4px;
  margin-bottom: 1px;
`
